var APIConfigModalTypes;
(function (APIConfigModalTypes) {
    APIConfigModalTypes["New"] = "new";
    APIConfigModalTypes["Delete"] = "delete";
})(APIConfigModalTypes || (APIConfigModalTypes = {}));
export { APIConfigModalTypes };
